<main class="flex w-full h-screen overflow-hidden">
    <!-- Sidebar: Fixed width, scrollable -->
    <app-sidebar class="w-[21rem] h-full overflow-y-auto hidden lg:block"></app-sidebar>
  
    <div class="flex flex-col w-full h-full">
      <!-- Navbar: Sticky at the top -->
      <app-navbar class=" w-full sticky top-0 z-10"></app-navbar>
  
      <!-- Main Content: Scrollable -->
      <div class="flex-1 w-full overflow-y-auto body">
        <div class="p-5 md:p-10 min-h-full"> <!-- Ensure full height and padding -->
          <router-outlet />
        </div>
      </div>
    </div>
  </main>
  